import {Injectable} from "@angular/core";

@Injectable()
export class GameSize {
  innerWidth = 500;
  innerHeight = 500;
  aspectRatio = 3 / 2;
  widthPart = 0.9;
  heightPart = 0.7;
  allowFlip = false;

  get innerAspect(): number {
    return this.innerWidth / this.innerHeight;
  }

  get height() {
    return this.innerHeight * this.heightPart;
  }

  get width() {
    return this.innerAspect > 1 || !this.allowFlip
      ? Math.min(this.widthPart * this.innerWidth, this.heightPart * this.innerHeight * this.aspectRatio)
      : Math.min(this.widthPart * this.innerWidth, this.heightPart * this.innerHeight / this.aspectRatio);
  }
}
